module.exports = __webpack_public_path__ + "static/media/messages.362057f9.svg";